import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, message, Modal, Upload } from 'antd'
import { inject, observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import { SendOutlined, SyncOutlined } from '@ant-design/icons'

const SalaryImportFileModal = props => {
  const {
    handleCloseSalaryImportFileModal,
    isVisibleSalaryImportFileModal,
    fileList,
    handleChangeFile,
    salaryStore,
  } = props

  const history = useHistory()
  const [isImporting, setIsImporting] = useState(false)

  const handleImportFile = async () => {
    if (fileList.length === 0) {
      return message.warning('Hãy chọn file!')
    }
    try {
      setIsImporting(true)
      const formData = new FormData()
      formData.append('file', fileList[0])
      await salaryStore.importSalaryFile(formData)
      handleCloseSalaryImportFileModal()
      message.success('Nhập thành công bảng lương!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsImporting(false)
    }
  }

  return (
    <Modal
      wrapClassName="custom-modal-wrapper"
      footer={null}
      closable={false}
      title={'Import dữ liệu bảng lương'}
      visible={isVisibleSalaryImportFileModal}>
      <h3 style={{ marginBottom: 12, fontSize: 18 }}>
        Bạn có chắc chắn muốn nhập file này?
      </h3>
      <ul style={{ paddingLeft: 0, listStyle: 'none', marginBottom: 20 }}>
        {fileList.map((item, index) => (
          <li style={{ fontSize: 16, color: 'blue' }} key={index}>
            {index + 1}. {item.name}
          </li>
        ))}
      </ul>

      <div
        className={'flex justify-end gap-3'}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 12,
        }}>
        <Button
          danger
          onClick={handleCloseSalaryImportFileModal}
          disabled={isImporting}
          style={{ marginRight: 'auto' }}>
          Hủy
        </Button>

        <Upload
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          valuePropName={'fileList'}
          fileList={fileList}
          onChange={handleChangeFile}
          beforeUpload={() => false}
          showUploadList={false}>
          <Button disabled={isImporting}>Chọn file khác</Button>
        </Upload>

        <Button
          loading={isImporting}
          onClick={handleImportFile}
          type={'primary'}>
          Xác nhận
        </Button>
      </div>
    </Modal>
  )
}

SalaryImportFileModal.propTypes = {
  isVisibleSalaryImportFileModal: PropTypes.bool.isRequired,
  handleCloseSalaryImportFileModal: PropTypes.func.isRequired,
  fileList: PropTypes.array,
  handleChangeFile: PropTypes.func,
}

export default inject('salaryStore')(observer(SalaryImportFileModal))
